import React, { useState } from "react";
import Styles from "./styles.module.scss";
import ImgHeroHrOneStop from "@Assets/Images/bg-hero-landing-jasa-hr-one-stop.png";
import ImgAdsLanding from "@Assets/Images/bg-hero-landing-pasang-iklan-loker.png";
import Icon from "@Atom/Icon";
import useWindowSize from "@Hooks/useWindowSize";
import { useNavigate } from "react-router-dom";

const TextToRender = [
  {
    title: "Jasa One Stop HR Solution",
    description:
      "Nikmati kemudahan dalam mencari tenaga kerja untuk bisnis Anda dengan bantuan kami.",
    link: "/business",
    img: ImgHeroHrOneStop,
  },
  {
    title: "Pasang Iklan Lowongan Kerja",
    description:
      "Akses ribuan data pekerja untuk lebih mudah cari tenaga kerja untuk bisnis Anda.",
    link: "/ads-landing-seekers",
    img: ImgAdsLanding,
  },
];

export default function PreLanding() {
  const [isHover, setIsHover] = useState(false);
  const { width } = useWindowSize();
  const navigate = useNavigate();
  return (
    <section className={Styles.containerWrapPreLanding}>
      {TextToRender.map((h, idx) => (
        <div
          className={Styles.heroImg}
          key={idx}
          onMouseEnter={() => (width >= 768 ? setIsHover(idx) : void {})}
        >
          <img
            src={h.img}
            alt={h.title}
            style={
              isHover !== false
                ? {
                    width: `${
                      isHover === idx
                        ? "65vw"
                        : isHover !== idx
                        ? "35vw"
                        : "50vw"
                    }`,
                  }
                : {}
            }
          />
          <div
            className={Styles.heroText}
            style={{
              transform: `scale(${isHover === idx ? "1.5" : "0.8"})`,
            }}
          >
            <div
              className={`${Styles.contain} ${
                idx === isHover && Styles.active
              } `}
            >
              <h1>{h.title}</h1>
              <p>{h.description}</p>
              <div
                className={Styles.buttonSave}
                onClick={() => navigate(h.link)}
              >
                <span className={Styles.searchText}>Baca Lebih Lanjut</span>
                <Icon icon={"arrow-right"} size={20} color={"#fff"} />
              </div>
            </div>
          </div>
        </div>
      ))}
    </section>
  );
}
